import Model from "./base/model";

class OrderAdditionalService extends Model{
  resourceName() {
    return "order_additional_services";
  }

  fields() {
    return {
      payment_type: "",
      value: "",
      request_type: "",
      description: "",
      confirmed:"",
      quantity:"",
      nf:"",
      icms:"",
      iss:"",
      percentage_icms:"",
      percentage_iss:"",
      additional_service: {jsonApi: "hasOne", type: "additional_services"},
      order: {jsonApi: "hasOne", type: "orders"},
      additional_services_files: {jsonApi: "hasMany", type: "order_additional_services_files"},
      order_id: "", // multiple
      additional_services: "", //multiple
      audits_additional_service: "",
      temp_id: "",
    }
  }
  async associate(data) {
    return this.request(
      this.resourceName() + "/associate",
      "POST",
      {},
      data
    );
  }
  async associateMultiple(data) {
    return this.request(
      this.resourceName() + "/associate_multiple",
      "POST",
      {},
      data
    );
  }
  async destroyAssociate(id) {
    return this.request(
      this.resourceName() + `/${id}` ,
      "DELETE",
      {}
    );
  }
  async confirmedAssociate(id, data) {
    return this.request(
      this.resourceName() + `/${id}` ,
      "PATCH",
      {},
      data
    );
  }
  async associateWithSimulationQuoteTransportersHash(hash,data) {
    return this.request(
      this.resourceName() + "/associate_with_simulation_quote_transporters_hash/"+hash,
      "POST",
      {},
      data
    );
  }
}

export default new OrderAdditionalService();
